'use client';

import { useRouter } from 'next/navigation';
import { PageType, PAGE_PATHS } from '@/components/Router';

export function useAppNavigate() {
  const router = useRouter();
  return (page: PageType) => {
    router.push(PAGE_PATHS[page]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
}
